var _path, _path2, _path3, _path4, _path5, _path6, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountStatements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 66 66",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m33 65c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32",
    fill: "#d9baa8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m56.9 38.3v-22.3c0-1.8-1.5-3.3-3.3-3.3s-3.3 1.5-3.3 3.3v22.3z",
    fill: "#a7cec8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m53.5 12.8c1.8 0 3.3 1.5 3.3 3.3v22h-6.6",
    style: {
      fill: "none",
      stroke: "#682f2a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m26.9 18.4v-2.4c0-1.8 1.5-3.3 3.3-3.3h23.3c-1.8 0-3.3 1.5-3.3 3.3v28c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3",
    fill: "#c5dfdc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m26.9 18.4v-2.4c0-1.8 1.5-3.3 3.3-3.3h23.3c-1.8 0-3.3 1.5-3.3 3.3v28c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3",
    style: {
      fill: "none",
      stroke: "#682f2a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.9 47.3h-9.9v-25.7c0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3v22.4c0 1.8 1.5 3.3 3.3 3.3",
    fill: "#a7cec8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m46.9 47.3h-9.9v-25.7c0-1.8 1.5-3.3 3.3-3.3s3.3 1.5 3.3 3.3v22.4c0 1.8 1.5 3.3 3.3 3.3z",
    style: {
      fill: "none",
      stroke: "#682f2a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m40.3 18.4c-1.8 0-3.3 1.5-3.3 3.3v28.3c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3v-1.4h-16.7v-27c0-1.8 1.5-3.3 3.3-3.3z",
    fill: "#ddedeb"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m40.3 18.4c-1.8 0-3.3 1.5-3.3 3.3v28.3c0 1.8-1.5 3.3-3.3 3.3s-3.3-1.5-3.3-3.3v-1.4h-16.7v-27c0-1.8 1.5-3.3 3.3-3.3z",
    style: {
      fill: "none",
      stroke: "#682f2a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 1.5
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m33.6 53.2h-20c-1.8 0-3.3-1.5-3.3-3.3v-1.4h20v1.5c0 1.8 1.5 3.2 3.3 3.2",
    fill: "#a7cec8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.6 53.2h-20c-1.8 0-3.3-1.5-3.3-3.3v-1.4h20v1.5c0 1.8 1.5 3.2 3.3 3.2z",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.1 28.8h-2.4c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h2.4c.9 0 1.7.8 1.7 1.7",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.6 28.8h2.4c.9 0 1.7.8 1.7 1.7s-.8 1.7-1.7 1.7h-2.4c-.9 0-1.7-.8-1.7-1.7",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 25.4v-.9",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.9 33.1v-.9",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 23.8h6.1",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 27.1h6.1",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 30.4h6.1",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 33.7h6.1",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 36.9h14.8",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 40.2h14.8",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 43.5h14.8",
    stroke: "#682f2a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.1 15.1h4",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 15.1h.8",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.9 21.1h4.1",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.8 21.1h.9",
    stroke: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountStatements);
export default __webpack_public_path__ + "static/media/account-statements.838d6c16072a3a69a7c4c3594df6adba.svg";
export { ForwardRef as ReactComponent };